import { ConstraintFragment } from '@occc/graphql';
import { getConstraintsByType } from '../constraints-section.utils';
import { GroupChipsOrViewAll } from '../../../components';

const getGroupsIds = (constraints: ConstraintFragment[]) => {
  const cst = getConstraintsByType('ConstraintStoreLocationGroup', constraints);
  return [...new Set(cst.flatMap((c) => c.locationGroups.map((v) => v.uuid)))];
};

export const StoreLocationGroupConstraint = ({
  constraints,
}: {
  constraints: ConstraintFragment[];
}) => {
  const groupIds = getGroupsIds(constraints);

  return (
    <GroupChipsOrViewAll label='Included Location Groups' description='Groups' ids={groupIds} />
  );
};
